<app-alert></app-alert>
<section>
  <div class="modal-header">
    <h5 class="modal-title" id="myModalLabelForDeletion">
      <i></i>Edit {{termSheetFieldToEdit.FieldName}} Term Sheet</h5>
    <button aria-label="Close" class="close" (click)="closeModal()" data-dismiss="modal" type="button">
      <i class="fa fa-times"></i>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="addNewTermsheetFieldForm">
      <div class="row form-group">

        <label class="col-md-3 control-label">{{termSheetFieldToEdit.FieldName}}</label>
        <div class="col-md-9">
          <!-- TEXT -->
          <input class="col-md-12 form-control" *ngIf="termSheetFieldToEdit.InputType == text || termSheetFieldToEdit.InputType == dropDownList"
            [value]="termSheetFieldToEdit.DefaultValue" formControlName="fieldValue" [disabled]="isMoreOptionOpened" required="required">
          <!-- NUMBER -->
          <input class="col-md-12 form-control" *ngIf="termSheetFieldToEdit.InputType == number"
            [value]="termSheetFieldToEdit.DefaultValue" formControlName="fieldValue" [disabled]="isMoreOptionOpened"
            (keydown)="onlyNumber($event)" required="required">
          <!-- NUMBERWITHOUTZERO -->
          <input class="col-md-12 form-control" *ngIf="termSheetFieldToEdit.InputType == numberWithoutZero"
            [value]="termSheetFieldToEdit.DefaultValue" formControlName="fieldValue" [disabled]="isMoreOptionOpened"
            (keydown)="onlyNumberWithoutZero($event)" required="required">
          <!-- SELECT DROPDOWN -->
          <!-- <select [disabled]="isMoreOptionOpened" class="col-md-12 form-control"
            *ngIf="termSheetFieldToEdit.InputType == dropDownList" formControlName="fieldValue" required="required">
            <option *ngFor="let option of termSheetFieldToEdit.ListOfValues; let count = index"
              [value]="termSheetFieldToEdit.DefaultValue">
              {{option["newFieldValue" + count]}}</option>
          </select> -->
        </div>
      </div>


      <div class="modal-footer">
        <button [disabled]="isMoreOptionOpened || addNewTermsheetFieldForm.controls['fieldValue'].hasError('required')  || disabledOnClick" class="btn btn-sm btn-primary mb-2"
          (click)="updateOnlyInTermsheet('Termsheet')">Update only in termsheet</button>
        <button [disabled]="isMoreOptionOpened || addNewTermsheetFieldForm.controls['fieldValue'].hasError('required')  || disabledOnClick" class="btn btn-sm btn-primary mb-2"
          *ngIf="termSheetFieldToEdit.LibraryId != null" (click)="updateOnlyInTermsheet('TermsheetNLibrary')">Update in termsheet & Library</button>
      </div>

      <section class="card search-box">
        <div class="card-header" data-toggle="collapse" data-target="#search-div-id" style="cursor: pointer;"
          (click)="clickedMoreOption()">More Options
          <span class="pull-right">
            <i class="fa fa-plus" aria-hidden="true"></i>
          </span>
        </div>
        <div class="card-block collapse" id="search-div-id">
          <div class="row" style="margin-top: 16px;">
            <div class="col-lg-12" style="height: 60px!important;">
              <!-- <form> -->
              <div class="row">
                <div class="col-md-3">
                  <label class="form-control-label">New Default Value :</label>
                </div>
                <div class="col-md-8">
                  <input type="text" class="form-control" name="newField" formControlName="newFieldValue" />
                </div>
                <div class="col-md-1" style="margin-left: -15px;">
                    <button class="btn btn-sm btn-primary mb-2" [disabled]="addNewTermsheetFieldForm.controls['newFieldValue'].hasError('required')  || disabledOnClick"
                      (click)="updateOnlyInTermsheet('Termsheet')">Update</button>
                </div>
              </div>
              <!-- </form> -->
            </div>
          </div>
        </div>
      </section>
    </form>

    <!-- <form [formGroup]="addNewTermsheetFieldForm" class="form-horizontal">  

        <div class="form-group" style="margin-top: 20px !important;">
          <label class="control-label col-sm-3 float-left" for="fieldName">Field Name</label>
          <div class="col-sm-9 float-left">
            <textarea class="form-control" id="fieldName" placeholder="" name="fieldName" formControlName="fieldName" readonly></textarea>
          </div>
        </div>
        <div class="clearfix"></div>

        <div class="form-group clearfix">
          <div class="col-sm-offset-2 col-sm-10">
            <button class="btn btn-success pull-right" (click)="addNewFields()" class="btn btn-sm btn-primary mb-2"
              type="button" style="margin-top: 25px;">
              <i class="fa fa-plus"></i>Add</button>
          </div>
        </div>

        
        <div class="col-md-12 clearfix" formArrayName="newField" *ngFor="let a of newFieldArray; let i = index;">
          <div [formGroupName]="i">
            <tr style="line-height: 42px;">
              <td tabindex="1" style="width:100% !important;">
                <input
                  *ngIf="termSheetFieldToEdit.InputType == 'Text' || termSheetFieldToEdit.InputType == 'DropDownSelection'"
                  type="text" class="form-control" name="{{'newFieldValue' + i }}" id="{{'newFieldValue' + i }}"
                  (keyup)="fieldValueChange(i)" formControlName="{{'newFieldValue'+ i}}" />

                <input *ngIf="termSheetFieldToEdit.InputType == 'Number'" type="text" class="form-control"
                  name="{{'newFieldValue' + i }}" id="{{'newFieldValue' + i }}" (keyup)="fieldValueChange(i)"
                  (keydown)="onlyNumber($event)" formControlName="{{'newFieldValue'+ i}}" />

              </td>
              <div *ngIf="addNewTermsheetFieldForm.controls['newField'].hasError('whitespace')"
              class="form-control-error-custom">
              Name is not valid.
          </div>
              <td style='white-space: nowrap'>
               
                <button type="button" class="btn-sm btn btn-danger" (click)="removeField(i)"
                  style="margin-left: 11px;margin-right: -4px;">
                  <span class="icmn-bin"></span>
                </button>
                <input type="checkbox" id="{{'defaultSelect' + i}}" name="defaultValue"
                  formControlName="{{'defaultValue'+ i}}" style="width: 27px; height: 18px;" class="radioCheck"
                  (change)="deafultSelectChange($event, i)">
                <label _ngcontent-c15="" for="{{'defaultSelect' + i}}"><span _ngcontent-c15=""
                    class="f-type-small"></span></label>
              </td>
            </tr>
          </div>
        </div>



      </form> -->
  </div>

</section>